import React from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { FormFeedback, Input } from 'reactstrap';
import ReadOnlyInput from './ReadOnlyInput';
import SelectComponent from './SelectComponent';

function SelectOrderNumber(props) {
  const store = useSelector(state => state)
  const { validation, edit, detail, detailIndex, addDetails } = props
  const { setFieldValue, handleBlur, handleChange, values, errors, touched, setFieldError } = validation

  const onChange = (e) => {
    if (e) {
      setFieldError(`details.${detailIndex}.orderId`, '')
      setFieldValue(`details.${detailIndex}.orderId`, e.value)
      setFieldValue(`details.${detailIndex}.orderNumber`, e.label)
      setFieldValue(`details.${detailIndex}.order`, e.order)
      setFieldValue(`details.${detailIndex}.brand`, e.brand)
      setFieldValue(`details.${detailIndex}.bunch`, e.bunch)
      setFieldValue(`details.${detailIndex}.fabricNumber`, e.fabricNumber)
      setFieldValue(`details.${detailIndex}.unitPrice`, e.unitPrice)
      setFieldValue(`details.${detailIndex}.activeColumn`, 1)
      setFieldValue(`details.${detailIndex}.companyName`, e.customerName)
    } else {
      setFieldValue(`details.${detailIndex}.orderId`, '')
      setFieldValue(`details.${detailIndex}.orderNumber`, '')
      setFieldValue(`details.${detailIndex}.order`, '')
      setFieldValue(`details.${detailIndex}.brand`, '')
      setFieldValue(`details.${detailIndex}.bunch`, '')
      setFieldValue(`details.${detailIndex}.fabricNumber`, '')
      setFieldValue(`details.${detailIndex}.unitPrice`, '')
      setFieldValue(`details.${detailIndex}.activeColumn`, '')
      setFieldValue(`details.${detailIndex}.companyName`, '')

    }

    addDetails(detailIndex)

  }

  if (edit || (detail.isIgarashi && detail.brand)) {
    return <ReadOnlyInput
      value={detail.orderNumber} />
  }
  return (
    <>
      <SelectComponent
        isLoading={store.fabricOrder.list.loading}
        isDisabled={edit}
        options={store.fabricOrder.list.data.map(i => ({ value: i.orderId, label: i.orderNumber, ...i }))}
        defaultValue={{
          value: detail.orderId,
          label: detail.orderNumber
        }}
        onChange={onChange}
        validation={validation}
        name="orderId"
      />

      <Input
        name="orderId"
        className="form-control d-none"
        type="text"
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.orderId || ""}
        invalid={
          (touched?.details && errors?.details) ?
            (touched?.details[detailIndex]?.orderId && errors?.details[detailIndex]?.orderId
              ? true
              : false) : false
        }
      />
      {touched?.details && errors?.details ? (
        <FormFeedback type="invalid">
          {errors?.details[detailIndex]?.orderId}
        </FormFeedback>
      ) : null}
    </>
  );
}

export default SelectOrderNumber;